import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { GymDbConnection } from '../db-connections/gym-db-connection';
import { ExcelImport } from '../entity/excel-import.entity';
import { GymInfoController } from './gym-info.controller';
import { GymInfoService } from './gym-info.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      ExcelImport
    ])
  ],
  controllers: [GymInfoController],
  providers: [GymInfoService, GymDbConnection, ApplicationExceptionHandler]
})
export class GymInfoModule {}
